__turbopack_context__.v({
  "__categories-list": "votes-history-module-scss-module__RgNE1a____categories-list",
  "__categories-list-item": "votes-history-module-scss-module__RgNE1a____categories-list-item",
  "__edit-button": "votes-history-module-scss-module__RgNE1a____edit-button",
  "__groups-list": "votes-history-module-scss-module__RgNE1a____groups-list",
  "__groups-list-item": "votes-history-module-scss-module__RgNE1a____groups-list-item",
  "__icon-container": "votes-history-module-scss-module__RgNE1a____icon-container",
  "__item": "votes-history-module-scss-module__RgNE1a____item",
  "__link-contents": "votes-history-module-scss-module__RgNE1a____link-contents",
  "__list-header": "votes-history-module-scss-module__RgNE1a____list-header",
  "__list-subheader": "votes-history-module-scss-module__RgNE1a____list-subheader",
  "__no-items": "votes-history-module-scss-module__RgNE1a____no-items",
  "__question-name": "votes-history-module-scss-module__RgNE1a____question-name",
  "__text-container": "votes-history-module-scss-module__RgNE1a____text-container",
  "__times-list": "votes-history-module-scss-module__RgNE1a____times-list",
  "__times-list-item": "votes-history-module-scss-module__RgNE1a____times-list-item",
  "__vote-count": "votes-history-module-scss-module__RgNE1a____vote-count",
  "__vote-name": "votes-history-module-scss-module__RgNE1a____vote-name",
  "__votes-list": "votes-history-module-scss-module__RgNE1a____votes-list",
  "__votes-list-item": "votes-history-module-scss-module__RgNE1a____votes-list-item",
  "votes-history": "votes-history-module-scss-module__RgNE1a__votes-history",
});
